import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "m-1" }
const _hoisted_3 = {
  class: "daily-attendance",
  style: {"background":"#f8f9fa","border":"2px solid #007bff","border-radius":"8px","padding":"20px","margin-bottom":"20px"}
}
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = { class: "p-col-6" }
const _hoisted_6 = {
  key: 0,
  style: {"color":"#28a745"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  style: {"color":"#6c757d"}
}
const _hoisted_10 = {
  class: "p-col-6",
  style: {"text-align":"right","display":"flex","align-items":"center","justify-content":"flex-end","gap":"10px"}
}
const _hoisted_11 = {
  style: {"margin":"0"},
  class: "p-fluid p-grid p-formgrid"
}
const _hoisted_12 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-4"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "m-0"
}
const _hoisted_15 = { class: "m-0" }
const _hoisted_16 = { class: "m-0" }
const _hoisted_17 = { class: "p-field bg-gray-200 p-col-12 p-md-8" }
const _hoisted_18 = {
  style: {"margin":"0"},
  class: "p-fluid p-grid p-formgrid"
}
const _hoisted_19 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_20 = { class: "m-1" }
const _hoisted_21 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_22 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_23 = { class: "m-1" }
const _hoisted_24 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_25 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_26 = { class: "m-1" }
const _hoisted_27 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_28 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_29 = { class: "m-1" }
const _hoisted_30 = {
  key: 0,
  class: "change-indicator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_chart = _resolveComponent("p-chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.report.employee_name?.length && _ctx.report.employee_name !== 'Admin1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.report.employee_name) + " ", 1),
            _createElementVNode("small", null, _toDisplayString(_ctx.report.employee_username), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { style: {"margin":"0 0 10px 0","color":"#007bff"} }, [
            _createElementVNode("i", { class: "pi pi-clock mr-2" }),
            _createTextVNode("Daily Attendance ")
          ], -1)),
          (_ctx.report.is_checked_in)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[0] || (_cache[0] = _createElementVNode("strong", null, "✓ Checked In", -1)),
                (_ctx.report.check_in_time)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "at " + _toDisplayString(_ctx.formatCheckInTime(_ctx.report.check_in_time)), 1))
                  : _createCommentVNode("", true),
                (_ctx.report.check_in_time)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Duration: " + _toDisplayString(_ctx.getCurrentDuration()), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("strong", null, "⏰ Not Checked In", -1),
                _createElementVNode("div", null, "Click Check In to start your day", -1)
              ]))]))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_p_button, {
            label: "Check In",
            icon: "pi pi-sign-in",
            class: "p-button-success",
            onClick: _ctx.doCheckIn,
            loading: _ctx.attendanceLoading,
            disabled: _ctx.report.is_checked_in
          }, null, 8, ["onClick", "loading", "disabled"]),
          _createVNode(_component_p_button, {
            label: "Check Out",
            icon: "pi pi-sign-out",
            class: "p-button-danger",
            onClick: _ctx.doCheckOut,
            loading: _ctx.attendanceLoading,
            disabled: !_ctx.report.is_checked_in
          }, null, 8, ["onClick", "loading", "disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_ctx.report.ranking)
          ? (_openBlock(), _createElementBlock("label", _hoisted_13, " Ranking "))
          : _createCommentVNode("", true),
        (_ctx.report.ranking)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_14, [
              _createElementVNode("b", null, _toDisplayString(_ctx.getOrdinalSuffix(_ctx.report.ranking)), 1)
            ]))
          : _createCommentVNode("", true),
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("label", null, " This Month's Target ", -1)),
        _createElementVNode("h1", _hoisted_15, [
          _createElementVNode("b", null, _toDisplayString(_ctx.formatToIndianNotation(_ctx.report.targets?.thisMonthTarget?.amount || 0)), 1)
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("label", null, " Ytd Target ", -1)),
        _createElementVNode("h1", _hoisted_16, [
          _createElementVNode("b", null, _toDisplayString(_ctx.formatToIndianNotation(_ctx.report.targets?.ytdTarget?.amount || 0)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_p_chart, {
          style: {"height":"400px"},
          type: "line",
          data: _ctx.report.lineChartData,
          options: _ctx.lineChartOptions
        }, null, 8, ["data", "options"]),
        _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-left" }, [
          _createElementVNode("b", null, "Performance by Day")
        ], -1)),
        _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1))
      ])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("small", { class: "m-3" }, "Overall Performance", -1)),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Leads Generated", -1)),
        _createElementVNode("h1", _hoisted_20, [
          _createTextVNode(_toDisplayString(((_ctx.report.mtdPerformance?.leadsGenerated || 0) + (_ctx.dashboard?.newLead || 0))?.toLocaleString()) + " ", 1),
          (!_ctx.hide_plus && _ctx.dashboard?.newLead)
            ? (_openBlock(), _createElementBlock("small", _hoisted_21, "+" + _toDisplayString(_ctx.dashboard.newLead?.toLocaleString()), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _cache[10] || (_cache[10] = _createElementVNode("label", null, "Converted Leads", -1)),
        _createElementVNode("h1", _hoisted_23, [
          _createTextVNode(_toDisplayString(((_ctx.report.mtdPerformance?.convertedLeads || 0) + (_ctx.dashboard?.convertLead || 0))?.toLocaleString()) + " ", 1),
          (!_ctx.hide_plus && _ctx.dashboard?.convertLead)
            ? (_openBlock(), _createElementBlock("small", _hoisted_24, "+" + _toDisplayString(_ctx.dashboard.convertLead?.toLocaleString()), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Revenue Generated", -1)),
        _createElementVNode("h1", _hoisted_26, [
          _createTextVNode(_toDisplayString(_ctx.formatToIndianNotation((_ctx.report.mtdPerformance?.revenueGenerated || 0) + (_ctx.dashboard?.revenueGenerated || 0))) + " ", 1),
          (!_ctx.hide_plus && _ctx.dashboard?.revenueGenerated)
            ? (_openBlock(), _createElementBlock("small", _hoisted_27, "+" + _toDisplayString(_ctx.dashboard.revenueGenerated?.toLocaleString()), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _cache[12] || (_cache[12] = _createElementVNode("label", null, "New Customers", -1)),
        _createElementVNode("h1", _hoisted_29, [
          _createTextVNode(_toDisplayString(((_ctx.report.mtdPerformance?.newCustomers || 0) + (_ctx.dashboard?.newCustomer || 0))?.toLocaleString()) + " ", 1),
          (!_ctx.hide_plus && _ctx.dashboard?.newCustomer)
            ? (_openBlock(), _createElementBlock("small", _hoisted_30, "+" + _toDisplayString(_ctx.dashboard.newCustomer?.toLocaleString()), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}